import { Poppins, Quicksand } from 'next/font/google'
import React, { useState } from 'react'
const popins = Poppins({weight:['400','500','600','700'],subsets:['latin'],display:'swap',preload:true})
const quickSand = Quicksand({weight:['400','500','600','700'],subsets:['latin'],display:'swap',preload:true})
import { FaChevronDown } from 'react-icons/fa';
export default function CourseFaq({faq,SectionRef,title,location1}) {

const [activeIndex,setActiveIndex] = useState(null);

const handleClick = (index)=>{
    setActiveIndex((prevIndex)=>(prevIndex === index ? null : index));
}

  return (
   <>
   <section className='bg-clr whole-pdtb' ref={SectionRef}>
    <div className='container'>
    <h2 className={`fs-30 tfs-28 mfs-21 fwb600 ${popins.className}`}> <span className={`ylw-clr ${popins.className}`}> FAQ 's about </span> {title} Training</h2>
<div className='faq-bg mt32'>
        <div className=' cursor'>
        {faq.map((items,index)=>{
    return(
           <div className='' key={index}>
            <div className='df fac fjsb pdtb20 ' onClick={()=>handleClick(index)}>
                <h3 className={`fs-16 mfs-15 fwb700 hvz ${quickSand.className} ${index === activeIndex ? "ylw-clr":""}`}>{items.ques}</h3>
                {/* {index === activeIndex ?(
                    <AiOutlineMinus className='' size={24} color='#000'/>
                ): <GoPlus className='' size={24} color='#000' />
                 } */}
                 <div className={`${index === activeIndex ? 'rotate-arrow' : 'rotate-normal'} fac`}>
                 <FaChevronDown className={`fs-20 tfs-18 mfs-16 `}/>
                 </div>
            </div>
            {index === activeIndex && (
                <p className={`fs-16 mfs-15 fwb500 ${quickSand.className}`}>{items.ans}</p>
            )}
            <div className='faq-line '></div>
            </div>
        )
    })}  
        </div>

</div>
    </div>
   </section>
   <style jsx>
    {`
    .bg-clr{
    background: #FEE9BF;
    }
    .hvz{
     transition:  all 0.4s linear;
    }
     .hvz:hover{
     color: #FFA900;
     }
    .title-box{
background: #FDCF7466;
width: 285px;
border-radius: 10px;
}
.faq-bg{
background: #FFFFFF;
width: auto;
height: auto;
padding: 20px;
border-radius: 10px;
box-shadow: 0px 0px 16px 0px #00000040;
}
.faq-line{
border: 1px solid #000;

}

    `}
   </style>
   </>
)
}
